import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/gabriel.machado/Documents/zapi-lp/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/gabriel.machado/Documents/zapi-lp/src/app/notFound.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gabriel.machado/Documents/zapi-lp/src/components/NotFoundRedirect.tsx");
